import getPath from 'lodash/get'
import { refCache } from './record-cache'

export const REFERENCE = function (field, key) {
  let refData = []
  let f = field
  let type = f.type
  if (f.referenceData) {
    if (Array.isArray(f.referenceData)) refData = f.referenceData
    else if (typeof f.referenceData === 'object') refData = [f.referenceData]
  }

  const get = function () {
    let refIds = this.$ && this.$.instance && this.$.instance.get(key)
    refIds = Array.prototype.concat(refIds).filter(x => x)
    let result = []
    for (let refId of refIds) {
      for (let rd of refData) {
        let res = refCache.get(rd.dataSourceId, rd.value, refId)
        if (res) result.push(res)
      }
      if (type === 'REFERENCE' || type === 'POLYREFERENCE') return result.length ? result[0] : undefined
    }
    return result.length ? result : undefined
  }

  const set = function (value) {
    let val = Array.prototype.concat(value)
    const arrValue = []
    for (let v of val) {
      if (v === null) {
        arrValue.push(null)
      } else if (typeof v === 'object') {
        let rd

        if (refData.length === 1) {
          rd = refData[0]
        } else if (v.$ && v.$.dataSourceId) {
          rd = refData.find(refd => refd.dataSourceId === v.$.dataSourceId)
        }

        if (rd && rd.value) {
          arrValue.push(getPath(v, rd.value))
        } else {
          arrValue.push(undefined)
        }
      } else if (typeof v === 'string' || typeof v === 'number') {
        arrValue.push(v)
      } else {
        arrValue.push(undefined)
      }
    }
    if (type === 'REFERENCE' || type === 'POLYREFERENCE') val = arrValue[0]
    else val = arrValue.filter(Boolean)

    const { resolvePath = key, dataSourceId, value: v } = f.referenceData || {}
    if (resolvePath && resolvePath !== key && this.$ && this.$.dataSourceId === dataSourceId) {
      refCache.addIfNew(dataSourceId, v, value[v], value)
    }

    if (resolvePath === key) {
      this.$.instance.set(key, val)
    }
  }
  return { get, set }
}

export const MULTIREFERENCE = REFERENCE
export const POLYREFERENCE = REFERENCE
export const POLYMULTIREFERENCE = REFERENCE
export const identity = (_, key) => {
  const get = function () {
    return this.$ && this.$.instance && this.$.instance.get(key)
  }
  const set = function (val) {
    this.$ && this.$.instance && this.$.instance.set(key, val)
  }
  return { get, set }
}
